@if (data) {
  <div>
    <div class="modal-header">
      <div class="container-fluid">
        <div class="row">
          <div class="col-lg" style="display: flex; align-items: center">
            <img class="mr-3 ml-2" style="width: 30px;" src='assets/ico/jira-icon-white.svg' alt="icon" />
            <span class="modal-title" id="modal-basic-title" >
              <span> {{'jiraUsers.creationTitle' | translate}} </span>
            </span>
          </div>
          <div class="modal-icon icon fill-white close-icon" (click)="close()" aria-label="close"
          [inlineSVG]="'assets/ico/close-24px.svg'"></div>
        </div>
      </div>
    </div>
    <div class="modal-body">
      @for (record of data; track record; let i = $index) {
        <div class="row m-0 mb-3 pl-5 pr-5 pt-2">
          @if (!record.isError) {
            <span class = 'sectionTitle isOk'>
              @if (record.user.user.syncStatus === 'ADDED') {
                <span> {{'jiraUsers.success' | translate }} {{record.target}} </span>
              }
              @if (record.user.user.syncStatus === 'NOT_MODIFIED') {
                <span> {{'jiraUsers.nodModified' | translate
                }} {{record.target}}</span>
              }
              @if (record.user.user.syncStatus === 'UPDATED') {
                <span> {{'jiraUsers.updated' | translate }} {{record.target}}
                </span>
              }
            </span>
          }
          @if (record.isError) {
            <span class = 'sectionTitle red-important'>
              Error while activating {{record.email}} on {{record.target}}
            </span>
          }
        </div>
        <div class="row m-0 mb-3 pl-5 pr-5 pt-2">
          <div class="col-lg-12 p-0 mb-3">
            @if (record.user && record.user.actions && record.user.actions.length > 1) {
              <ul
                style="margin-left: -20px; margin-bottom: 0px;">
                @for (action of record.user.actions; track action) {
                  <li>
                    {{action}}
                  </li>
                }
              </ul>
            }
            @if (record.user && record.user.actions && record.user.actions.length == 1) {
              <div>
                {{record.user.actions[0]}}
              </div>
            }
            @if (record.user.user) {
              <div class="mt-3">
                @if (record.user.user  && record.user.user.syncStatus) {
                  <span>Sync Status:
                    <strong>{{record.user.user.syncStatus}}</strong><br /></span>
                  }
                  @if (record.user.user  && record.user.user.key) {
                    <span>User Key:
                      <strong>{{record.user.user.key}}</strong><br /></span>
                    }
                    @if (record.user.user  && record.user.user.name) {
                      <span>User Name:
                        <strong>{{record.user.user.name}}</strong><br /></span>
                      }
                    </div>
                  }
                  @if (record.user.userGroupResponse && record.user.userGroupResponse.groups && record.user.userGroupResponse.groups.length > 0) {
                    <div class="mt-3"
                      >
                      <div style="font-size: 20px; font-weight: 800; font-style: italic; margin-bottom: 10px; padding-top: 15px;">Applications</div>
                      @for (item of record.user.userGroupResponse.groups; track item; let i = $index) {
                        <div class="group-label">{{item.label}}</div>
                        @if (item.groups.length > 0) {
                          <ul>
                            @for (item of item.groups; track item) {
                              <li><span style="font-style: italic;">{{item.groupName}}:</span>&nbsp;{{item.action}} </li>
                            }
                          </ul>
                        }
                      }
                    </div>
                  }
                </div>
              </div>
            }
          </div>
          <div class="modal-footer p-0">
            <div class="container-fluid m-0 p-0">
              <span class="btn modal-btn save back" (click)="close()">{{'jiraUsers.done' | translate }}</span>
              @for (record of data.slice().reverse(); track record; let i = $index) {
                @if (record.user.user && record.user.user.link) {
                  <a ngbTooltip="{{'jiraUsers.permission' | translate}}"
                    placement="top" container="body" triggers="hover" tooltipClass="apc-tooltip-top"
                    [href]="record.user.user.link" class="btn modal-btn save" target="_blank">{{'jiraUsers.goto' | translate
                  }} {{record.target}}</a>
                }
              }
            </div>
          </div>
        </div>
      }